var PROJ = (typeof PROJ === 'object') ? PROJ : {};

/**
 * Locale/market root from Shopify (e.g. "/" or "/en-us/").
 * @returns {string}
 */
PROJ.shopRoot = function () {
    if (window.Shopify && Shopify.routes && typeof Shopify.routes.root === 'string') {
        return Shopify.routes.root;
    }
    if (window.Theme && Theme.routes && Theme.routes.cart_url) {
        return String(Theme.routes.cart_url).replace(/\/cart\/?$/, '/');
    }
    return '/';
};

/**
 * Build a market-aware cart path (e.g. "cart/add.js" → "/en-us/cart/add.js").
 * @param {string} path
 * @returns {string}
 */
PROJ.cartUrl = function (path) {
    var root = PROJ.shopRoot();
    if (root.slice(-1) !== '/') root += '/';
    return root + String(path || '').replace(/^\//, '');
};

/**
 * True when form is the theme product add-to-cart form (action may be locale-prefixed).
 * @param {Element | null} form
 * @returns {boolean}
 */
PROJ.isProductCartForm = function (form) {
    if (!form || !form.classList || !form.classList.contains('fs-product-form')) return false;
    var action = form.getAttribute('action') || '';
    return /\/cart\/add\/?$/.test(action);
};

/**
 * First product cart form under root (or document).
 * @param {ParentNode | null | undefined} root
 * @returns {HTMLFormElement | null}
 */
PROJ.queryProductCartForm = function (root) {
    var scope = root || document;
    if (!scope || !scope.querySelectorAll) return null;
    var forms = scope.querySelectorAll('form.fs-product-form');
    for (var i = 0; i < forms.length; i++) {
        if (PROJ.isProductCartForm(forms[i])) return forms[i];
    }
    return null;
};

/**
 * All product cart forms under root (or document).
 * @param {ParentNode | null | undefined} root
 * @returns {HTMLFormElement[]}
 */
PROJ.queryProductCartForms = function (root) {
    var scope = root || document;
    if (!scope || !scope.querySelectorAll) return [];
    return Array.prototype.filter.call(scope.querySelectorAll('form.fs-product-form'), PROJ.isProductCartForm);
};

/**
 * Show the matching .jsp-pitem inside a card .onetime-price (supports more than CSS nth-child rules).
 * @param {Element | null} onetimeEl
 */
function syncJspcOnetimePriceDisplay(onetimeEl) {
    if (!onetimeEl || !onetimeEl.classList.contains('onetime-price')) return;
    var idx = parseInt(onetimeEl.getAttribute('data-shows'), 10);
    if (isNaN(idx)) idx = 0;
    onetimeEl.querySelectorAll('.jsp-pitem').forEach(function (item, i) {
        item.style.display = i === idx ? 'flex' : 'none';
    });
}

/**
 * Update card add-to-cart link from a select option (variant or grouped product).
 * @param {Element} jspcAddWrap
 * @param {HTMLOptionElement} selectedOption
 * @param {string | null | undefined} explicitVariantId When set (e.g. data-directadd on group options), used instead of option.value
 */
function updateJspcAddCtaFromOption(jspcAddWrap, selectedOption, explicitVariantId) {
    var jspcAddStyle = jspcAddWrap.querySelector('.jspc-add-style');
    if (!jspcAddStyle || !selectedOption) return;

    var isAvailable = selectedOption.getAttribute('data-available') === 'true';
    var eta = selectedOption.getAttribute('data-eta') || '';
    var isPreorder = selectedOption.getAttribute('data-preorder') === 'true' || !!eta;
    var variantId =
        explicitVariantId != null && String(explicitVariantId).length > 0
            ? String(explicitVariantId)
            : selectedOption.value;

    var ctaText = 'Add To Cart';

    if (!isAvailable) {
        ctaText = 'Sold Out';
        jspcAddStyle.classList.add('jspc-sold');
        jspcAddStyle.removeAttribute('data-directadd');
    } else {
        jspcAddStyle.classList.remove('jspc-sold');
        if (variantId) {
            jspcAddStyle.setAttribute('data-directadd', variantId);
        }

        if (isPreorder) {
            ctaText = eta ? 'Pre-Order - ' + eta : 'Pre-Order';
        }
    }

    jspcAddStyle.textContent = ctaText;
}

/**
 * Load card add-to-cart block for another product (section rendering).
 * @param {string} productUrl Product URL path (e.g. /products/handle)
 * @param {Element} currentFormContainer .jspc-add-wrap
 * @param {Element | null} cardRoot .js-card
 * @param {{ name?: string | null, url?: string | null, image?: string | null }} cardMeta
 * @returns {Promise<void>}
 */
function fetchAndReplaceJspcCardAdd(productUrl, currentFormContainer, cardRoot, cardMeta) {
    if (!productUrl || !currentFormContainer) return Promise.resolve();
    cardMeta = cardMeta || {};
    var url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', 'zpro-ajax-card-product');
    return fetch(url.toString())
        .then(function (response) {
            return response.text();
        })
        .then(function (html) {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            var newFormContainer = tempDiv.querySelector('.jspc-add-wrap');
            if (!newFormContainer) return;

            currentFormContainer.innerHTML = newFormContainer.innerHTML;

            if (cardRoot) {
                if (cardMeta.name) {
                    var cardTitle = cardRoot.querySelector('.jspc-title');
                    if (cardTitle) cardTitle.textContent = cardMeta.name;
                }
                if (cardMeta.url) {
                    cardRoot.querySelectorAll('a.jspc-img-in, a.jsp-details-top').forEach(function (link) {
                        link.setAttribute('href', cardMeta.url);
                    });
                    cardRoot.querySelectorAll('a.jspc-pdlink').forEach(function (link) {
                        var qvUrl = cardMeta.url;
                        qvUrl += qvUrl.indexOf('?') >= 0 ? '&' : '?';
                        qvUrl += 'view=quickview';
                        link.setAttribute('href', qvUrl);
                    });
                }
                if (cardMeta.image) {
                    var cardImage = cardRoot.querySelector('.jspc-img img');
                    if (cardImage && cardImage instanceof HTMLImageElement) {
                        cardImage.src = cardMeta.image;
                        cardImage.srcset = cardMeta.image;
                    }
                }
            }

            var ot = currentFormContainer.querySelector('.onetime-price');
            if (ot) syncJspcOnetimePriceDisplay(ot);
        });
}

PROJ.pdp = {
    VAR: {},
    /**
     * After main line item is added, optionally add checked PDP add-ons from [data-pdp-bundle-list] in the same .st-pdp-layout as the form.
     */
    addOptionalPdpAddonLineItems: function (form, mainItem) {
        return new Promise(function (resolve) {
            if (!form) {
                resolve();
                return;
            }
            var scope =
                (form.closest && form.closest('.st-pdp-layout')) ||
                document.querySelector('.st-pdp-layout') ||
                document;
            var listRoot = scope.querySelector('[data-pdp-bundle-list]');
            if (!listRoot) {
                resolve();
                return;
            }
            var mainId = '';
            if (mainItem && mainItem.variant_id != null) {
                mainId = String(mainItem.variant_id);
            }
            try {
                var fd = new FormData(form);
                var fid = fd.get('id');
                if (fid != null && fid !== '') {
                    mainId = String(fid);
                }
            } catch (e) {}
            var ids = [];
            listRoot.querySelectorAll('.pdp-addons__checkbox:checked').forEach(function (cb) {
                if (mainId && String(cb.value) === mainId) {
                    return;
                }
                ids.push(cb.value);
            });
            if (!ids.length) {
                resolve();
                return;
            }
            var step = 0;
            function next() {
                if (step >= ids.length) {
                    resolve();
                    return;
                }
                fetch(PROJ.cartUrl('cart/add.js'), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: ids[step], quantity: 1 })
                })
                    .then(function (res) {
                        return res.json().then(function (body) {
                            if (!res.ok) {
                                throw body;
                            }
                            return body;
                        });
                    })
                    .then(function () {
                        step += 1;
                        next();
                    })
                    .catch(function () {
                        resolve();
                    });
            }
            next();
        });
    },
    /**
     * Format cents as money for PDP main ATC mirror (uses data-money-* on [data-pdp-main-atc]).
     * @param {number} cents
     * @param {Element | null} cfgRoot
     * @returns {string}
     */
    formatPdpMainAtcMoney: function (cents, cfgRoot) {
        var n = Number(cents);
        if (!isFinite(n)) {
            return '';
        }
        var locale = (cfgRoot && cfgRoot.getAttribute('data-money-locale')) || 'en';
        var currency = (cfgRoot && cfgRoot.getAttribute('data-money-currency')) || 'USD';
        var withCode = cfgRoot && cfgRoot.getAttribute('data-money-with-code') === '1';
        try {
            return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currency,
                currencyDisplay: withCode ? 'code' : 'narrowSymbol'
            }).format(n / 100);
        } catch (e) {
            return (n / 100).toFixed(2);
        }
    },
    /**
     * Build price HTML for PDP – Main add to cart mirror: " - sale<s>list</s>" from variant + optional PDP product list checkboxes.
     * @param {Element} layout .st-pdp-layout or document
     * @param {HTMLFormElement} form
     * @returns {string | null} null = fall back to copying main .pr innerHTML
     */
    buildPdpMainAtcMirrorPriceHtml: function (layout, form) {
        if (!form) {
            return null;
        }
        var selectBox = form.querySelector('.pr-variants');
        if (!selectBox || selectBox.selectedIndex < 0) {
            return null;
        }
        var sel = selectBox.options[selectBox.selectedIndex];
        if (!sel) {
            return null;
        }
        var pc = parseInt(sel.getAttribute('data-price-cents'), 10);
        var plc = parseInt(sel.getAttribute('data-list-cents'), 10);
        if (!isFinite(pc)) {
            return null;
        }
        if (!isFinite(plc)) {
            plc = pc;
        }
        var listRoot = layout.querySelector('[data-pdp-bundle-list]');
        var addonPc = 0;
        var addonLc = 0;
        if (listRoot) {
            listRoot.querySelectorAll('.pdp-addons__checkbox:checked').forEach(function (cb) {
                var ap = parseInt(cb.getAttribute('data-pdp-addon-price-cents'), 10);
                var al = parseInt(cb.getAttribute('data-pdp-addon-list-cents'), 10);
                if (isFinite(ap)) {
                    addonPc += ap;
                }
                if (isFinite(al)) {
                    addonLc += al;
                } else if (isFinite(ap)) {
                    addonLc += ap;
                }
            });
        }
        var totalSale = pc + addonPc;
        var totalList = plc + addonLc;
        var cfgRoot = layout.querySelector('[data-pdp-main-atc]');
        var saleStr = PROJ.pdp.formatPdpMainAtcMoney(totalSale, cfgRoot);
        var html = ' - ' + saleStr;
        if (totalList > totalSale) {
            html += '<s>' + PROJ.pdp.formatPdpMainAtcMoney(totalList, cfgRoot) + '</s>';
        }
        return html;
    },
    /**
     * Default Add to cart label (block setting on layout mirror, or theme product form default).
     * @param {HTMLFormElement} form
     * @returns {string}
     */
    getPdpDefaultAtcLabel: function (form) {
        if (!form) {
            return 'Add to cart';
        }
        var wrap = form.closest('[data-pdp-main-atc]');
        if (wrap) {
            var fromBlock = wrap.getAttribute('data-pdp-default-atc-label');
            if (fromBlock != null && String(fromBlock).length) {
                return fromBlock;
            }
        }
        var pfc = form.closest('product-form-component');
        if (pfc) {
            var fromPfc = pfc.getAttribute('data-atc-default');
            if (fromPfc != null && String(fromPfc).length) {
                return fromPfc;
            }
        }
        return 'Add to cart';
    },
    /**
     * Primary ATC label: Pre-Order + optional var.eta (same rules as snippets/zpro-card-add.liquid).
     * Pre-order when data-preorder is true, or when var.eta (data-eta) is set — even if in stock.
     * @param {HTMLFormElement} form
     * @param {HTMLOptionElement | null} matchedOption
     * @param {HTMLButtonElement | null} addToCartBtn
     */
    applyPdpAddToCartButtonLabel: function (form, matchedOption, addToCartBtn) {
        if (!addToCartBtn) {
            return;
        }
        var atb = addToCartBtn.querySelector('.atb');
        if (!atb) {
            return;
        }
        var def = PROJ.pdp.getPdpDefaultAtcLabel(form);
        if (!matchedOption) {
            atb.textContent = def;
            return;
        }
        var av = matchedOption.getAttribute('data-available');
        var eta = matchedOption.getAttribute('data-eta') || '';
        var pre = matchedOption.getAttribute('data-preorder') === 'true' || !!eta;
        if (av === 'true' && pre) {
            atb.textContent = eta ? 'Pre-Order - ' + eta : 'Pre-Order';
        } else {
            atb.textContent = def;
        }
    },
    /** Keep PDP – Main add to cart mirror buttons in sync with the real .fs-product-form .addtocart (price + sold state). */
    syncPdpMainAtcMirrors: function (thisform) {
        if (!thisform) {
            return;
        }
        var layout =
            (thisform.closest && thisform.closest('.st-pdp-layout')) ||
            document.querySelector('.st-pdp-layout');
        if (!layout) {
            layout = document;
        }
        var mainBtn = thisform.querySelector('.addtocart');
        var prEl = mainBtn && mainBtn.querySelector('.pr');
        var mirrorPriceHtml = PROJ.pdp.buildPdpMainAtcMirrorPriceHtml(layout, thisform);
        layout.querySelectorAll('[data-pdp-main-atc]').forEach(function (root) {
            var mBtn = root.querySelector('[data-pdp-main-atc-submit]');
            var mPr = root.querySelector('[data-pdp-main-atc-price]');
            if (mPr) {
                if (mirrorPriceHtml != null) {
                    mPr.innerHTML = mirrorPriceHtml;
                } else if (prEl) {
                    mPr.innerHTML = prEl.innerHTML;
                }
            }
            if (mBtn && mainBtn) {
                mBtn.disabled = !!mainBtn.disabled;
                mBtn.classList.toggle('deactive', mainBtn.classList.contains('deactive'));
                mBtn.classList.toggle('disabled', mainBtn.classList.contains('disabled'));
                var mAtb = mBtn.querySelector('.atb');
                var mainAtb = mainBtn.querySelector('.atb');
                if (mAtb && mainAtb) {
                    mAtb.textContent = mainAtb.textContent;
                }
            }
        });
        if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.syncStickyAtc === 'function') {
            PROJ.pdp.syncStickyAtc(thisform);
        }
    },
    /**
     * Sticky ATC: button label is Add To Cart / Pre-Order / Sold out (no ETA); keep select in sync with form variant.
     * @param {HTMLFormElement | null} thisform
     */
    syncStickyAtc: function (thisform) {
        var sticky = document.querySelector('[data-sticky-atc]');
        if (!sticky || sticky.closest('.zpro-quickview__pdp, [data-quickview-content], #zpro-quickview')) {
            return;
        }
        var layoutEl = document.querySelector('.st-pdp-layout:not(.zpro-quickview__pdp)');
        var form =
            thisform ||
            (layoutEl && PROJ.queryProductCartForm(layoutEl)) ||
            PROJ.queryProductCartForm(document);
        var mainBtn = form && form.querySelector('.addtocart');
        var stickyBtn = sticky.querySelector('[data-sticky-atc-submit]');
        var selectBox = form && form.querySelector('.pr-variants');
        var matched = selectBox && selectBox.selectedIndex >= 0 ? selectBox.options[selectBox.selectedIndex] : null;
        var def = sticky.getAttribute('data-sticky-atc-default-label') || 'Add To Cart';

        if (stickyBtn && mainBtn) {
            stickyBtn.disabled = !!mainBtn.disabled;
            stickyBtn.classList.toggle('deactive', mainBtn.classList.contains('deactive'));
            stickyBtn.classList.toggle('disabled', mainBtn.classList.contains('disabled'));
            var atb = stickyBtn.querySelector('.atb');
            if (atb) {
                var pre =
                    matched &&
                    (matched.getAttribute('data-preorder') === 'true' || !!(matched.getAttribute('data-eta') || ''));
                if (matched && matched.getAttribute('data-available') === 'true' && pre) {
                    atb.textContent = 'Pre-Order';
                } else {
                    atb.textContent = def;
                }
            }
        }

        var stickyVariantSelect = sticky.querySelector('[data-sticky-atc-select][data-sticky-mode="variant"]');
        if (stickyVariantSelect && matched && stickyVariantSelect.querySelector('option[value="' + matched.value + '"]')) {
            stickyVariantSelect.value = matched.value;
        }

        var staticPrice = sticky.querySelector('[data-sticky-atc-price]');
        if (staticPrice && matched) {
            var cents = parseInt(matched.getAttribute('data-price-cents'), 10);
            if (isFinite(cents)) {
                var cfg = document.querySelector('[data-pdp-main-atc]');
                staticPrice.textContent = PROJ.pdp.formatPdpMainAtcMoney(cents, cfg);
            }
        }
    },
    /**
     * Show sticky ATC when the main PDP ATC button is out of the viewport.
     */
    initStickyAtc: function () {
        if (PROJ.pdp._stickyAtcInit) {
            return;
        }
        var sticky = document.querySelector('[data-sticky-atc]');
        if (!sticky || sticky.closest('.zpro-quickview__pdp, [data-quickview-content], #zpro-quickview')) {
            return;
        }
        PROJ.pdp._stickyAtcInit = true;

        // container-type on .st-pdp-layout creates a containing block; pin to body for true viewport fixed.
        if (sticky.parentNode !== document.body) {
            document.body.appendChild(sticky);
        }

        var layout =
            document.querySelector('.st-pdp-layout:not(.zpro-quickview__pdp)') ||
            document;
        var observeTarget =
            layout.querySelector('[data-pdp-main-atc] [data-pdp-main-atc-submit]') ||
            layout.querySelector('[data-pdp-main-atc]');

        function setStickyVisible(visible) {
            sticky.hidden = !visible;
            sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
            sticky.classList.toggle('is-visible', !!visible);
        }

        if (observeTarget && typeof IntersectionObserver === 'function') {
            var rect = observeTarget.getBoundingClientRect();
            var inView = rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight);
            setStickyVisible(!inView);

            var io = new IntersectionObserver(
                function (entries) {
                    var entry = entries && entries[0];
                    if (!entry) {
                        return;
                    }
                    setStickyVisible(!entry.isIntersecting);
                },
                { root: null, threshold: 0, rootMargin: '0px' }
            );
            io.observe(observeTarget);
        } else {
            setStickyVisible(false);
        }

        sticky.addEventListener('change', function (e) {
            var sel = e.target;
            if (!sel || !sel.matches || !sel.matches('[data-sticky-atc-select]')) {
                return;
            }
            var mode = sel.getAttribute('data-sticky-mode');
            var opt = sel.options[sel.selectedIndex];
            if (!opt) {
                return;
            }
            if (mode === 'group') {
                var url = opt.getAttribute('data-product-url');
                if (url) {
                    window.location.href = url;
                }
                return;
            }
            if (mode === 'variant') {
                var form =
                    PROJ.queryProductCartForm(layout) ||
                    PROJ.queryProductCartForm(document);
                if (form && typeof PROJ.pdp.applyVariantFromPdpVariantLink === 'function') {
                    PROJ.pdp.applyVariantFromPdpVariantLink(form, opt);
                    var vid = opt.getAttribute('data-variant-id') || opt.value;
                    layout.querySelectorAll('a.pdp-option-card[data-pdp-inline-variant]').forEach(function (card) {
                        card.classList.toggle('active', String(card.getAttribute('data-variant-id')) === String(vid));
                    });
                    var head = layout.querySelector('.pdp-option-links__head--variant .pdp-option-links__title span');
                    if (head) {
                        var text = opt.textContent || '';
                        var dashAt = text.lastIndexOf(' - ');
                        head.textContent = dashAt > -1 ? text.slice(0, dashAt).trim() : text.trim();
                    }
                }
            }
        });
    },
    /**
     * Sync fs-product-form option UI from a PDP – Variant Links card, then run updateForm (URL, price, ATC, mirrors).
     * @param {HTMLFormElement} form
     * @param {HTMLAnchorElement} link Variant card with data-variant-option1..3 (handleized) and data-variant-id
     */
    applyVariantFromPdpVariantLink: function (form, link) {
        if (!form || !link) {
            return;
        }
        var vidEarly = link.getAttribute('data-variant-id');
        var selEarly = form.querySelector('.pr-variants');
        if (vidEarly && selEarly && selEarly.querySelector('option[value="' + vidEarly + '"]')) {
            selEarly.value = vidEarly;
            try {
                var puEarly = window.location.origin + window.location.pathname;
                window.history.replaceState({}, '', puEarly + '?variant=' + vidEarly);
            } catch (errEarly) {}
        }
        var o1 = link.getAttribute('data-variant-option1') || '';
        var o2 = link.getAttribute('data-variant-option2') || '';
        var o3 = link.getAttribute('data-variant-option3') || '';
        var handles = [o1, o2, o3];
        var comps = form.querySelectorAll('option-compenent[data-oselected-value]');
        comps.forEach(function (comp, i) {
            var h = handles[i];
            if (!h) {
                return;
            }
            comp.setAttribute('data-oselected-value', h);
            comp.querySelectorAll('[data-o-value]').forEach(function (sibling) {
                sibling.classList.remove('active');
            });
            var clicked = comp.querySelector('[data-o-value="' + h + '"]');
            if (clicked) {
                clicked.classList.add('active');
                var zopTitle = comp.querySelector('.zop-title');
                if (zopTitle) {
                    var span = zopTitle.querySelector('span');
                    if (span) {
                        var newTitle = clicked.getAttribute('title') || '';
                        span.textContent = newTitle ? ' ' + newTitle.trim() : '';
                    }
                }
            }
        });
        if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.updateForm === 'function') {
            PROJ.pdp.updateForm(form);
        }
        var cardsWrap = link.closest('.pdp-option-links__cards');
        if (cardsWrap) {
            cardsWrap.querySelectorAll('a.pdp-option-card[data-pdp-inline-variant]').forEach(function (c) {
                c.classList.remove('active');
            });
            link.classList.add('active');
        }
        var variantHead = link.closest('.pdp-option-links') && link.closest('.pdp-option-links').querySelector('.pdp-option-links__head--variant .pdp-option-links__title span');
        if (variantHead) {
            var lab = link.querySelector('.pdp-option-card__label');
            variantHead.textContent = lab ? lab.textContent.trim() : '';
        }
    },
    syncDetailDropdownPanels: function (scope) {
        if (!scope || !scope.querySelectorAll) {
            return;
        }
        scope
            .querySelectorAll(
                '.pdp-detail-dropdown-wraps .ac-title.active, .pdp-detail-dropdown:not(.st-pdp-faq__item) .ac-title.active'
            )
            .forEach(function (title) {
                var panel = title.nextElementSibling;
                if (panel && panel.classList.contains('active')) {
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                }
            });
    },
    initDetailDropdownDelegation: function () {
        if (PROJ.pdp._detailDropdownDelegation) {
            return;
        }
        PROJ.pdp._detailDropdownDelegation = true;
        document.body.addEventListener('click', function (e) {
            var title = e.target.closest(
                '.pdp-detail-dropdown-wraps .ac-title, .pdp-detail-dropdown:not(.st-pdp-faq__item) .ac-title'
            );
            if (!title) {
                return;
            }
            e.preventDefault();
            var panel = title.nextElementSibling;
            if (!panel) {
                return;
            }
            if (title.classList.contains('active')) {
                panel.style.maxHeight = '0';
                title.classList.remove('active');
                panel.classList.remove('active');
            } else {
                panel.style.maxHeight = panel.scrollHeight + 'px';
                title.classList.add('active');
                panel.classList.add('active');
                setTimeout(function () {
                    var scrollEl = title.closest('[data-quickview-content]');
                    var rect = title.getBoundingClientRect();
                    if (scrollEl) {
                        var containerRect = scrollEl.getBoundingClientRect();
                        var topPadding = 24;
                        var visible =
                            rect.top >= containerRect.top + topPadding &&
                            rect.bottom <= containerRect.bottom;
                        if (!visible) {
                            scrollEl.scrollTo({
                                top:
                                    rect.top -
                                    containerRect.top -
                                    topPadding +
                                    scrollEl.scrollTop,
                                behavior: 'smooth'
                            });
                        }
                    } else {
                        var vh = window.innerHeight;
                        var winTopPadding = 100;
                        if (rect.top < winTopPadding || rect.bottom > vh) {
                            window.scrollTo({
                                top: window.scrollY + rect.top - winTopPadding,
                                behavior: 'smooth'
                            });
                        }
                    }
                }, 1000);
            }
        });
    },
    initBundleItemsToggleDelegation: function () {
        if (PROJ.pdp._bundleItemsToggleDelegation) {
            return;
        }
        PROJ.pdp._bundleItemsToggleDelegation = true;
        document.body.addEventListener('click', function (e) {
            var btn = e.target.closest('.pdp-bundle-items__toggle');
            if (!btn) {
                return;
            }
            var root = btn.closest('.pdp-bundle-items');
            if (!root) {
                return;
            }
            var expanded = root.classList.toggle('is-expanded');
            btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            var more = root.querySelector('[data-pdp-bundle-more]');
            if (more) {
                more.setAttribute('aria-hidden', expanded ? 'false' : 'true');
            }
            var label = btn.querySelector('.pdp-bundle-items__toggle-label');
            var collapsedText = btn.getAttribute('data-label-collapsed');
            var expandedText = btn.getAttribute('data-label-expanded');
            if (label && collapsedText && expandedText) {
                label.textContent = expanded ? expandedText : collapsedText;
            }
        });
    },
    init: function () {
        var _this = this;
        this.initDetailDropdownDelegation();
        this.initBundleItemsToggleDelegation();
        if (typeof this.initStickyAtc === 'function') {
            this.initStickyAtc();
        }
        if (this.promoProgress && typeof this.promoProgress.init === 'function') {
            this.promoProgress.init();
        }
        document.body.addEventListener('change', function (e) {
            var t = e.target;
            if (!t || !t.classList || !t.classList.contains('pdp-addons__checkbox')) {
                return;
            }
            var layout = (t.closest && t.closest('.st-pdp-layout')) || document.querySelector('.st-pdp-layout');
            if (!layout) {
                return;
            }
            var form = PROJ.queryProductCartForm(layout);
            if (form && typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.syncPdpMainAtcMirrors === 'function') {
                PROJ.pdp.syncPdpMainAtcMirrors(form);
            }
            if (typeof PROJ !== 'undefined' && PROJ.pdp && PROJ.pdp.promoProgress) {
                PROJ.pdp.promoProgress.syncOffersBarInLayout(
                    (t.closest && t.closest('.st-pdp-layout')) ||
                        document.querySelector('.st-pdp-layout:not(.zpro-quickview__pdp)')
                );
            }
        });
        document.body.addEventListener('change', function (e) {
            var sel = e.target;
            if (!sel || !sel.classList || !sel.classList.contains('pr-variants')) {
                return;
            }
            var layoutSel =
                (sel.closest && sel.closest('.st-pdp-layout')) ||
                document.querySelector('.st-pdp-layout:not(.zpro-quickview__pdp)');
            if (layoutSel && PROJ.pdp && PROJ.pdp.promoProgress) {
                PROJ.pdp.promoProgress.syncOffersBarInLayout(layoutSel);
            }
        });
        document.body.addEventListener('click', function (e) {
            var vLink = e.target.closest('a.pdp-option-card[data-pdp-inline-variant]');
            if (vLink) {
                var href = vLink.getAttribute('href');
                if (href) {
                    var url;
                    try {
                        url = new URL(vLink.href, window.location.origin);
                    } catch (err) {
                        url = null;
                    }
                    var inQuickview = vLink.closest('[data-quickview-content]');
                    if (inQuickview || (url && url.pathname === window.location.pathname)) {
                        var layout =
                            (vLink.closest && vLink.closest('.st-pdp-layout')) ||
                            document.querySelector('.st-pdp-layout') ||
                            document;
                        var form = PROJ.queryProductCartForm(layout);
                        if (form && typeof PROJ.pdp.applyVariantFromPdpVariantLink === 'function') {
                            e.preventDefault();
                            PROJ.pdp.applyVariantFromPdpVariantLink(form, vLink);
                            return;
                        }
                    }
                }
            }

            var mirror = e.target.closest('[data-pdp-main-atc-submit]');
            if (!mirror || mirror.disabled) {
                return;
            }
            e.preventDefault();
            var wrap = mirror.closest('[data-pdp-main-atc]');
            var scope =
                (wrap && wrap.closest('.st-pdp-layout')) ||
                document.querySelector('.st-pdp-layout') ||
                document;
            var form =
                (wrap && wrap.querySelector('form.fs-product-form')) ||
                PROJ.queryProductCartForm(scope);
            if (form) {
                form.requestSubmit();
            }
        });
        // This can be ajax loaded content, so use event delegation for dynamically added forms
        document.body.addEventListener('submit', function (e) {
            var form = e.target;
            if (PROJ.isProductCartForm(form)) {
                e.preventDefault();
                var inQuickView = !!form.closest('[data-quickview-content], #zpro-quickview');
                var debugMiniCart = false;
                try {
                    debugMiniCart =
                        window.location.search.indexOf('debug_minicart=1') >= 0 ||
                        window.localStorage.getItem('debug_minicart') === '1';
                } catch (err) {}
                function mcLog() {
                    if (!debugMiniCart || !window.console) return;
                    try {
                        // eslint-disable-next-line no-console
                        console.log.apply(console, ['[pdp-atc]'].concat([].slice.call(arguments)));
                    } catch (err) {}
                }

                var addToCartBtn = form.querySelector('.addtocart');
                if (addToCartBtn) {
                    addToCartBtn.classList.add('disabled');
                    addToCartBtn.disabled = true;
                }
                if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.syncPdpMainAtcMirrors === 'function') {
                    PROJ.pdp.syncPdpMainAtcMirrors(form);
                }
                if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.syncPrVariantSelectBeforeCartAdd === 'function') {
                    PROJ.pdp.syncPrVariantSelectBeforeCartAdd(form);
                }

                var variantSelect = form.querySelector('.pr-variants');
                var selectedVariantOption =
                    variantSelect &&
                    (variantSelect.selectedOptions[0] ||
                        (variantSelect.selectedIndex >= 0
                            ? variantSelect.options[variantSelect.selectedIndex]
                            : null));
                if (
                    selectedVariantOption &&
                    selectedVariantOption.getAttribute('data-available') === 'false'
                ) {
                    if (addToCartBtn) {
                        addToCartBtn.classList.add('deactive');
                        addToCartBtn.disabled = true;
                    }
                    if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.syncPdpMainAtcMirrors === 'function') {
                        PROJ.pdp.syncPdpMainAtcMirrors(form);
                    }
                    return;
                }

                var formData = new FormData(form);
                mcLog('submit intercepted', { id: formData.get('id'), qty: formData.get('quantity') });

                function reenableAtc() {
                    if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.updateForm === 'function') {
                        PROJ.pdp.updateForm(form);
                    } else {
                        if (addToCartBtn) {
                            addToCartBtn.classList.remove('disabled');
                            addToCartBtn.disabled = false;
                        }
                        if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.syncPdpMainAtcMirrors === 'function') {
                            PROJ.pdp.syncPdpMainAtcMirrors(form);
                        }
                    }
                }

                function doAddToCart() {
                    return fetch(PROJ.cartUrl('cart/add.js'), {
                        method: 'POST',
                        body: new URLSearchParams(formData),
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                        }
                    })
                        .then(function (response) {
                            return response.json().then(function (data) {
                                return { response: response, data: data };
                            });
                        })
                        .then(function (result) {
                            var response = result.response;
                            var data = result.data;
                            mcLog('cart/add result', { ok: response.ok, status: response.status, variant_id: data && data.variant_id });
                            reenableAtc();
                            if (response.ok && data && data.variant_id) {
                                return PROJ.pdp.addOptionalPdpAddonLineItems(form, data).then(function () {
                                    if (inQuickView && typeof PROJ !== 'undefined' && PROJ.quickview && typeof PROJ.quickview.close === 'function') {
                                        PROJ.quickview.close();
                                    }
                                    if (typeof PROJ !== 'undefined' && PROJ.ajaxcart && typeof PROJ.ajaxcart.updateCart === 'function') {
                                        // After optional add-on line-items are synced, open minicart.
                                        mcLog('syncing minicart after add-ons');
                                        PROJ.ajaxcart.updateCart().then(function () {
                                            if (typeof PROJ.ajaxcart.opencart === 'function') {
                                                mcLog('opening minicart');
                                                PROJ.ajaxcart.opencart();
                                            }
                                        });
                                    }
                                    return true;
                                });
                            }
                            if (response.ok && typeof PROJ !== 'undefined' && PROJ.ajaxcart && typeof PROJ.ajaxcart.updateCart === 'function') {
                                if (inQuickView && PROJ.quickview && typeof PROJ.quickview.close === 'function') {
                                    PROJ.quickview.close();
                                }
                                // Wait for mini-cart HTML sync, then open/animate drawer.
                                mcLog('syncing minicart');
                                PROJ.ajaxcart.updateCart().then(function () {
                                    if (typeof PROJ.ajaxcart.opencart === 'function') {
                                        mcLog('opening minicart');
                                        PROJ.ajaxcart.opencart();
                                    }
                                });
                                return true;
                            }
                            return !!response.ok;
                        })
                        .catch(function (error) {
                            mcLog('cart/add error', error);
                            reenableAtc();
                            if (typeof PROJ !== 'undefined' && PROJ.ajaxcart && typeof PROJ.ajaxcart.updateCart === 'function') {
                                PROJ.ajaxcart.updateCart();
                            }
                            console.error('Error adding item to cart:', error);
                            return false;
                        });
                }

                var needsAgeCheck =
                    typeof PROJ !== 'undefined' &&
                    PROJ.ageVerification &&
                    typeof PROJ.ageVerification.formRequiresAgeCheck === 'function' &&
                    PROJ.ageVerification.formRequiresAgeCheck(form);

                if (needsAgeCheck) {
                    PROJ.ageVerification.ensureConsent({ writeOnConfirm: false }).then(function (ok) {
                        if (!ok) {
                            reenableAtc();
                            return;
                        }
                        return PROJ.ageVerification.recordConsent()
                            .then(function () {
                                var minicartCheckbox = PROJ.ageVerification.getMinicartCheckbox && PROJ.ageVerification.getMinicartCheckbox();
                                if (minicartCheckbox) {
                                    minicartCheckbox.checked = true;
                                    PROJ.ageVerification.setMinicartCheckoutLocked(false);
                                }
                                return doAddToCart();
                            })
                            .catch(function (err) {
                                console.error('Age verification: failed to save consent', err);
                                reenableAtc();
                            });
                    });
                    return;
                }

                doAddToCart();
            }
        });


        // Handle option swatch/item clicks for custom product form

        ['click', 'touchstart'].forEach(eventType => {
            document.body.addEventListener(eventType, function (e) {

                let target = e.target;

                // for product option clicks
                if (target.closest('[data-o-value]')) {
                    e.preventDefault();
                    let clicked = target.closest('[data-o-value]');

                    var clickedValue = clicked.getAttribute('data-o-value');
                    var parentOption = clicked.closest('[data-oselected-value]');
                    if (!parentOption) return;

                    // Update parent [data-oselected-value] attribute
                    parentOption.setAttribute('data-oselected-value', clickedValue);

                    // Remove 'active' from siblings, add to clicked
                    var siblings = clicked.parentElement.querySelectorAll('[data-o-value]');
                    siblings.forEach(function (sibling) {
                        sibling.classList.remove('active');
                    });
                    clicked.classList.add('active');

                    // Update .zop-title > span text under this option using title attribute
                    var zopTitle = parentOption.querySelector('.zop-title');
                    if (zopTitle) {
                        var span = zopTitle.querySelector('span');
                        if (span) {
                            // Replace text with clicked item's title attribute
                            var newTitle = clicked.getAttribute('title') || '';
                            span.textContent = newTitle;
                        }
                    }

                    // Call updateForm at the end
                    if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.updateForm === 'function') {
                        PROJ.pdp.updateForm(parentOption.closest('form'));
                    }
                }
                if (target.closest('.jsp-gitem')) {
                    let clicked = target.closest('.jsp-gitem');

                    // Get the parent .sp-product-form-container of the clicked element in the current DOM
                    var currentFormContainer = clicked.closest('.sp-product-form-container');

                    // Check if direct load is enabled
                    var directLoad = false;
                    if (currentFormContainer) {
                        var directLoadAttr = currentFormContainer.getAttribute('data-direct-load');
                        directLoad = directLoadAttr === 'true';
                    }

                    // If direct load is enabled, navigate directly to product page (no JavaScript intervention needed)
                    if (directLoad) {
                        // Allow default link behavior - navigate directly to product page
                        return;
                    }

                    // Otherwise, prevent default and do AJAX load
                    e.preventDefault();

                    // Keep the first [data-oselected-value] value from parent .sp-product-form-container
                    var keptValue = null;
                    if (currentFormContainer) {
                        var firstOSelected = currentFormContainer.querySelector('[data-oselected-value]');
                        if (firstOSelected) {
                            keptValue = firstOSelected.getAttribute('data-oselected-value');
                        }
                    }

                    // Get the href link from the clicked .jsp-gitem and add section_id for AJAX load
                    var href = clicked.getAttribute('href');
                    if (href) {
                        // Add section_id parameter for AJAX load
                        var url = new URL(href, window.location.origin);
                        url.searchParams.set('section_id', 'zpro-ajax-product');
                        var ajaxUrl = url.toString();

                        fetch(ajaxUrl)
                            .then(function(response) {
                                return response.text();
                            })
                            .then(function(html) {
                                // Create a temporary DOM to parse the fetched HTML
                                var tempDiv = document.createElement('div');
                                tempDiv.innerHTML = html;
                                // Find the .sp-product-form-container in the fetched HTML
                                var newFormContainer = tempDiv.querySelector('.sp-product-form-container');
                                if (newFormContainer) {
                                    // Replace the content inside the current container with the new one
                                    if (currentFormContainer) {
                                        currentFormContainer.innerHTML = newFormContainer.innerHTML;

                                        // Update product title from data-pr-name attribute
                                        var productName = clicked.getAttribute('data-pr-name');
                                        if (productName) {
                                            var titleElement = document.querySelector('.slp-title');
                                            if (titleElement) {
                                                titleElement.textContent = productName;
                                            }
                                        }

                                        // Update product image from data-pr-image attribute
                                        var productImage = clicked.getAttribute('data-pr-image');
                                        if (productImage) {
                                            var firstImage = document.querySelector('.fs-main-gal .fs-med img');
                                            if (firstImage && firstImage instanceof HTMLImageElement) {
                                                firstImage.src = productImage;
                                                // Also update srcset if it exists
                                                if (firstImage.srcset) {
                                                    firstImage.srcset = productImage;
                                                }
                                            }
                                        }

                                        // Scroll Flickity gallery to first slide
                                        var mainGallery = document.querySelector('.fs-main-gal');
                                        if (mainGallery && typeof Flickity !== 'undefined') {
                                            var flickityInstance = Flickity.data(mainGallery);
                                            if (flickityInstance) {
                                                flickityInstance.select(0);
                                            }
                                        }

                                        // After load, check for first [data-oselected-value] and child [data-o-value] with kept value, and trigger click
                                        if (keptValue !== null) {
                                            var firstOSelectedNew = currentFormContainer.querySelector('[data-oselected-value]');
                                            if (firstOSelectedNew) {
                                                var matchingChild = firstOSelectedNew.querySelector('[data-o-value][data-o-value="' + keptValue + '"]');
                                                if (matchingChild) {
                                                    matchingChild.click();
                                                }
                                            }
                                        }
                                    }
                                }
                                // Change the web url to the clean product URL (without section_id)
                                var cleanUrl = new URL(href, window.location.origin).pathname;
                                window.history.replaceState({}, '', cleanUrl);
                            })
                            .catch(function(error) {
                                // Optionally handle errors
                                console.error('Error fetching product form:', error);
                            });
                    }
                }



            });
        });


    },
    /**
     * Match variant <option> by concatenated handleized options (same as Liquid data-options).
     * @param {HTMLSelectElement} selectBox
     * @param {string} combinedValue
     * @returns {HTMLOptionElement | null}
     */
    findFsFormVariantOptionByDataOptions: function (selectBox, combinedValue) {
        if (!selectBox) {
            return null;
        }
        var want = combinedValue == null ? '' : String(combinedValue);
        var opts = selectBox.querySelectorAll('option[value]');
        for (var i = 0; i < opts.length; i++) {
            var opt = opts[i];
            if ((opt.getAttribute('data-options') || '') === want) {
                return opt;
            }
        }
        return null;
    },
    /**
     * Keep hidden .pr-variants in sync with URL (?variant=) or option-compenent picks before cart/add.js.
     * Fixes wrong line item when the mirror ATC submits while the select was never updated.
     */
    syncPrVariantSelectBeforeCartAdd: function (form) {
        if (!form) {
            return;
        }
        var selectBox = form.querySelector('.pr-variants');
        if (!selectBox || selectBox.options.length === 0) {
            return;
        }
        if (selectBox.options.length === 1) {
            selectBox.value = selectBox.options[0].value;
            return;
        }
        var vidParam = '';
        try {
            vidParam = new URLSearchParams(window.location.search).get('variant') || '';
        } catch (err) {}
        if (vidParam && /^\d+$/.test(vidParam)) {
            for (var j = 0; j < selectBox.options.length; j++) {
                if (selectBox.options[j].value === vidParam) {
                    selectBox.value = vidParam;
                    return;
                }
            }
        }
        var combinedValue = '';
        form.querySelectorAll('option-compenent[data-oselected-value]').forEach(function (el) {
            var val = el.getAttribute('data-oselected-value');
            if (val) {
                combinedValue += val;
            }
        });
        var matched = PROJ.pdp.findFsFormVariantOptionByDataOptions(selectBox, combinedValue);
        if (matched) {
            selectBox.value = matched.value;
        }
    },
    updateForm: function (thisform) {
        if (!thisform) return;

        var selectedOptionEls = thisform.querySelectorAll('option-compenent[data-oselected-value]');
        var combinedValue = '';
        selectedOptionEls.forEach(function (el) {
            var val = el && el.getAttribute && el.getAttribute('data-oselected-value');
            if (val) {
                combinedValue += val;
            }
        });

        var selectBox = thisform.querySelector('.pr-variants');
        var addToCartBtn = thisform.querySelector('.addtocart');
        if (selectBox) {
            var matchedOption = null;
            if (selectBox.options.length === 1) {
                matchedOption = selectBox.options[0];
            } else {
                matchedOption = PROJ.pdp.findFsFormVariantOptionByDataOptions(selectBox, combinedValue);
                if (!matchedOption && combinedValue === '') {
                    var vidParam = '';
                    try {
                        vidParam = new URLSearchParams(window.location.search).get('variant') || '';
                    } catch (err2) {}
                    if (vidParam && /^\d+$/.test(vidParam)) {
                        for (var k = 0; k < selectBox.options.length; k++) {
                            if (selectBox.options[k].value === vidParam) {
                                matchedOption = selectBox.options[k];
                                break;
                            }
                        }
                    }
                }
                if (!matchedOption && selectBox.value) {
                    matchedOption = selectBox.selectedOptions[0] || null;
                }
            }
            if (matchedOption) {
                selectBox.value = matchedOption.value;
                var event = new Event('change', {bubbles: true});
                selectBox.dispatchEvent(event);

                var qvScope = thisform.closest('[data-qv-product-path]');
                var productPath = qvScope ? qvScope.getAttribute('data-qv-product-path') : null;
                if (!qvScope) {
                    var productUrl = window.location.origin + window.location.pathname;
                    var newUrl = productUrl + '?variant=' + matchedOption.value;
                    window.history.replaceState({}, '', newUrl);
                }

                if (addToCartBtn) {
                    var isAvailable = matchedOption.getAttribute('data-available');
                    if (isAvailable === 'false') {
                        addToCartBtn.classList.add('deactive');
                        addToCartBtn.setAttribute('disabled', 'disabled');
                    } else {
                        addToCartBtn.classList.remove('deactive');
                        addToCartBtn.classList.remove('disabled');
                        addToCartBtn.removeAttribute('disabled');
                    }

                    var varPrice = matchedOption.getAttribute('data-var-price');
                    if (varPrice) {
                        var prEl = addToCartBtn.querySelector('.pr');
                        if (prEl) {
                            prEl.innerHTML = ' - ' + varPrice;
                        }
                    }
                    if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.applyPdpAddToCartButtonLabel === 'function') {
                        PROJ.pdp.applyPdpAddToCartButtonLabel(thisform, matchedOption, addToCartBtn);
                    }
                }
            } else {
                if (addToCartBtn) {
                    addToCartBtn.classList.add('deactive');
                    addToCartBtn.setAttribute('disabled', 'disabled');
                    if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.applyPdpAddToCartButtonLabel === 'function') {
                        PROJ.pdp.applyPdpAddToCartButtonLabel(thisform, null, addToCartBtn);
                    }
                }
            }
        } else {
            if (addToCartBtn) {
                addToCartBtn.classList.add('deactive');
                addToCartBtn.setAttribute('disabled', 'disabled');
                if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.applyPdpAddToCartButtonLabel === 'function') {
                    PROJ.pdp.applyPdpAddToCartButtonLabel(thisform, null, addToCartBtn);
                }
            }
        }

        if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.syncPdpMainAtcMirrors === 'function') {
            PROJ.pdp.syncPdpMainAtcMirrors(thisform);
        }
        if (PROJ.pdp.promoProgress) {
            PROJ.pdp.promoProgress.syncOffersBarInLayout(
                (thisform.closest && thisform.closest('.st-pdp-layout')) ||
                    document.querySelector('.st-pdp-layout:not(.zpro-quickview__pdp)')
            );
        }
    },
    updateCart: function () {
        location.reload();
    },
    /**
     * PDP offer progress bar: frozen cart + current variant at page load; bundle checkboxes add on top.
     */
    promoProgress: {
        getMarketRate: function () {
            return Number(
                (typeof window.market_exchange_rate !== 'undefined' && window.market_exchange_rate) ||
                    (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate) ||
                    1
            ) || 1;
        },
        getMarketSymbol: function (root) {
            if (root && root.getAttribute('data-market-symbol')) {
                return root.getAttribute('data-market-symbol');
            }
            return typeof market_symbol !== 'undefined' ? market_symbol : '$';
        },
        addonCountsTowardCollection: function (cb, collectionId) {
            if (!collectionId) {
                return true;
            }
            var ids = cb.getAttribute('data-pdp-addon-collection-ids') || '';
            return ids.indexOf(String(collectionId)) !== -1;
        },
        getCurrentVariantCents: function (root) {
            if (!root) {
                return 0;
            }
            var collectionId = root.getAttribute('data-progress-collection-id') || '';
            var productOk = root.getAttribute('data-product-in-collection') === '1';
            if (collectionId && !productOk) {
                return 0;
            }
            var layout =
                (root.closest && root.closest('.st-pdp-layout')) ||
                document.querySelector('.st-pdp-layout:not(.zpro-quickview__pdp)');
            if (!layout) {
                return 0;
            }
            var form = PROJ.queryProductCartForm(layout);
            if (!form) {
                return 0;
            }
            var selectBox = form.querySelector('.pr-variants');
            var sel =
                selectBox &&
                selectBox.selectedIndex >= 0 &&
                selectBox.options[selectBox.selectedIndex];
            if (!sel) {
                return 0;
            }
            var pc = parseInt(sel.getAttribute('data-price-cents'), 10);
            return isFinite(pc) ? pc : 0;
        },
        getCheckedAddonCents: function (root) {
            if (!root) {
                return 0;
            }
            var wrap = root.closest('.pdp-addons-wrap');
            var bundleRoot = wrap && wrap.querySelector('[data-pdp-bundle-list]');
            if (!bundleRoot) {
                return 0;
            }
            var collectionId = root.getAttribute('data-progress-collection-id') || '';
            var total = 0;
            bundleRoot.querySelectorAll('.pdp-addons__checkbox:checked').forEach(function (cb) {
                if (!PROJ.pdp.promoProgress.addonCountsTowardCollection(cb, collectionId)) {
                    return;
                }
                var ap = parseInt(cb.getAttribute('data-pdp-addon-price-cents'), 10);
                if (isFinite(ap)) {
                    total += ap;
                }
            });
            return total;
        },
        getProgressCents: function (root) {
            if (!root) {
                return 0;
            }
            var base = Number(root.getAttribute('data-cart-progress-base') || 0);
            if (!isFinite(base)) {
                base = 0;
            }
            return (
                base +
                PROJ.pdp.promoProgress.getCurrentVariantCents(root) +
                PROJ.pdp.promoProgress.getCheckedAddonCents(root)
            );
        },
        syncOffersBarInLayout: function (layout) {
            var scope =
                layout ||
                document.querySelector('.st-pdp-layout:not(.zpro-quickview__pdp)') ||
                document;
            if (!scope || scope.classList.contains('zpro-quickview__pdp')) {
                return;
            }
            scope.querySelectorAll('[data-pdp-promo-progress]').forEach(function (root) {
                PROJ.pdp.promoProgress.animateRoot(root);
            });
        },
        prepareRoot: function (root) {
            if (!root) {
                return false;
            }
            var realItems = root.querySelectorAll(
                '.pdp-offers-bar__item:not(.is-empty)[data-target]'
            );
            var maxTarget = 0;
            realItems.forEach(function (item) {
                var v = Number(item.getAttribute('data-target') || 0);
                if (v > maxTarget) {
                    maxTarget = v;
                }
            });
            if (!realItems.length || maxTarget <= 0) {
                root.classList.add('pdp-offers-bar-wrap--empty');
                return false;
            }
            root.classList.remove('pdp-offers-bar-wrap--empty');
            var lastSpacer = root.querySelector('.pdp-offers-bar__item.is-empty.last');
            if (lastSpacer) {
                lastSpacer.setAttribute('data-target', String(Math.round(maxTarget * 1.2)));
            }
            return true;
        },
        animateRoot: function (root) {
            if (!root) {
                return;
            }
            if (!PROJ.pdp.promoProgress.prepareRoot(root)) {
                return;
            }
            var rate = PROJ.pdp.promoProgress.getMarketRate();
            var symbol = PROJ.pdp.promoProgress.getMarketSymbol(root);
            var progress = PROJ.pdp.promoProgress.getProgressCents(root);
            var locks = root.querySelectorAll('.pdp-offers-bar__items .pdp-offers-bar__item');
            var fill = root.querySelector('.pdp-offers-bar__fill');

            if (!locks.length || locks.length < 2 || !fill) {
                return;
            }

            var gap = 100 / (locks.length - 1);
            var current_target;
            var next_target;

            locks.forEach(function (target) {
                target.classList.remove('is-met', 'active');
                var targetValue = Number(target.getAttribute('data-target') || 0);
                if (targetValue > 0) {
                    var amountEl = target.querySelector('.pdp-offers-bar__amount');
                    if (amountEl) {
                        amountEl.textContent =
                            symbol + Math.round((targetValue * rate) / 100);
                    }
                }
            });

            locks.forEach(function (target, i) {
                var targetValue = Number(target.getAttribute('data-target') || 0);
                if (targetValue > 0 && progress >= targetValue) {
                    current_target = target;
                    next_target = locks[i + 1];
                    target.classList.add('is-met', 'active');
                }
            });

            if (next_target && current_target) {
                var currentTargetValue = Number(
                    current_target.getAttribute('data-target') || 0
                );
                var nextTargetValue = Number(next_target.getAttribute('data-target') || 0);
                var extraval =
                    nextTargetValue > currentTargetValue
                        ? (progress - currentTargetValue) /
                          (nextTargetValue - currentTargetValue)
                        : 0;
                var barwidth =
                    Array.prototype.indexOf.call(locks, current_target) * gap +
                    gap * extraval;
                fill.style.width = Math.min(100, Math.max(0, barwidth)) + '%';
                return;
            }

            if (progress <= 0) {
                fill.style.width = '0%';
                return;
            }

            var firstReal = root.querySelector(
                '.pdp-offers-bar__item:not(.is-empty)[data-target]'
            );
            var firstVal = firstReal
                ? Number(firstReal.getAttribute('data-target') || 0)
                : 0;
            if (firstReal && firstVal > 0 && progress < firstVal) {
                var leadExtraval = progress / firstVal;
                fill.style.width = Math.min(100, Math.max(0, gap * leadExtraval)) + '%';
                return;
            }

            fill.style.width = '100%';
        },
        init: function () {
            document
                .querySelectorAll('.st-pdp-layout:not(.zpro-quickview__pdp) [data-pdp-promo-progress]')
                .forEach(function (root) {
                    PROJ.pdp.promoProgress.animateRoot(root);
                });
        }
    }
};

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-card .onetime-price').forEach(syncJspcOnetimePriceDisplay);
    PROJ.pdp.init();
    PROJ.queryProductCartForms(document).forEach(function (f) {
        if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.updateForm === 'function') {
            PROJ.pdp.updateForm(f);
        } else if (typeof PROJ !== 'undefined' && PROJ.pdp && typeof PROJ.pdp.syncPdpMainAtcMirrors === 'function') {
            PROJ.pdp.syncPdpMainAtcMirrors(f);
        }
    });
    // PROJ.ajaxcart.init();

    // fetch(location.pathname+'?section_id=zpro-product-quotes-all')
    //     .then(r=>r.text())
    //     .then(h=>{
    //         let d=document.createElement('div');
    //         d.innerHTML=h;
    //         document.body.appendChild(d.firstElementChild);
    //     });

    // loadProductSection('white-1-4-fold-cocktail-100-organic-cotton-8-x-8-folded-4-x-4-30-units');

});

//quote section load
function loadProductSection(productHandle) {
    document.querySelector('body').classList.add('fs-popup');
    document.querySelector('html').classList.add('fs-popup');

    fetch(`/products/${productHandle}?section_id=zpro-product-quotes-all`)
        .then(r=>r.text())
        .then(h=>{
            let d=document.createElement('div');
            d.innerHTML=h;
            document.body.appendChild(d.firstElementChild);

        // INSERT_YOUR_CODE
        setTimeout(function() {
            var fixpopQuotes = document.querySelector('.fixpop-quotes');
            if (fixpopQuotes) {
                fixpopQuotes.classList.add('active');
            }
        }, 1000);

        });

}



document.addEventListener('click', function (e) {
    let target = e.target;

    if (target.classList.contains('clossquotes')) {
        e.preventDefault();
        document.querySelector('body').classList.remove('fs-popup');
        document.querySelector('html').classList.remove('fs-popup');
    }

    if (target.hasAttribute('data-quotes')) {
        document.querySelector('body').classList.add('fs-popup');
        document.querySelector('html').classList.add('fs-popup');

        var productHandle = target.getAttribute('data-quotes');

    // INSERT_YOUR_CODE

    if (productHandle && productHandle.trim() !== "") {
        var chtml = document.querySelector('.fixpop-quotes .content-pop');
        if (chtml) {
            chtml.innerHTML =  productHandle;
        }
    }

    }

    //Product Card
    //product card change bundle products
    if (target.closest('.jsp-add')) {
        var clicked = target.closest('.jsp-add');
        e.preventDefault();

        var currentFormContainer = clicked.closest('.jspc-add-wrap');
        var keptValue = null;
        if (currentFormContainer) {
            var firstOSelected = currentFormContainer.querySelector('[data-oselected-value]');
            if (firstOSelected) {
                keptValue = firstOSelected.getAttribute('data-oselected-value');
            }
        }

        var href = clicked.getAttribute('href');
        if (href && currentFormContainer) {
            var cardRoot = clicked.closest('.js-card');
            fetchAndReplaceJspcCardAdd(href, currentFormContainer, cardRoot, {
                name: clicked.getAttribute('data-card-name'),
                url: clicked.getAttribute('data-card-url') || href,
                image: clicked.getAttribute('data-card-image')
            })
                .then(function () {
                    if (keptValue !== null && currentFormContainer) {
                        var firstOSelectedNew = currentFormContainer.querySelector('[data-oselected-value]');
                        if (firstOSelectedNew) {
                            var matchingChild = firstOSelectedNew.querySelector('[data-o-value][data-o-value="' + keptValue + '"]');
                            if (matchingChild) {
                                matchingChild.click();
                            }
                        }
                    }
                })
                .catch(function (error) {
                    console.error('Error fetching product form:', error);
                });
        }
    }



    // Handle quantity selector button clicks
    if (target.closest('.sbp-qs') && target.matches('button')) {
        e.preventDefault();
        var button = target;
        var sbpQs = button.closest('.sbp-qs');

        if (sbpQs) {
            var input = sbpQs.querySelector('.quantity-input');

            if (input) {
                var currentValue = parseInt(input.value) || 0;
                var min = parseInt(input.getAttribute('min')) || 1;
                var max = parseInt(input.getAttribute('max')) || Infinity;
                var newValue = currentValue;

                if (button.classList.contains('quantity-minus')) {
                    newValue = Math.max(min, currentValue - 1);
                } else if (button.classList.contains('quantity-plus')) {
                    newValue = Math.min(max, currentValue + 1);
                }

                if (newValue !== currentValue) {
                    input.value = newValue;
                    // Trigger input event to notify any listeners
                    var inputEvent = new Event('input', { bubbles: true });
                    input.dispatchEvent(inputEvent);
                }
            }
        }
    }

});

// Handle .jspc-price select change
document.addEventListener('change', function (e) {
    var target = e.target;

    if (target && target.matches && target.matches('.jspc-group-select')) {
        var groupSelect = target;
        var jspcAddWrap = groupSelect.closest('.jspc-add-wrap');
        var cardRoot = groupSelect.closest('.js-card');
        var selectedOption = groupSelect.options[groupSelect.selectedIndex];
        if (!jspcAddWrap || !selectedOption) return;

        var onetimePrice = jspcAddWrap.querySelector('.onetime-price');
        if (onetimePrice) {
            onetimePrice.setAttribute('data-shows', String(groupSelect.selectedIndex));
            syncJspcOnetimePriceDisplay(onetimePrice);
        }

        var directId = selectedOption.getAttribute('data-directadd');
        updateJspcAddCtaFromOption(jspcAddWrap, selectedOption, directId);

        var fetchUrl = selectedOption.getAttribute('data-fetch-url');
        if (fetchUrl) {
            fetchAndReplaceJspcCardAdd(fetchUrl, jspcAddWrap, cardRoot, {
                name: selectedOption.getAttribute('data-card-name'),
                url: selectedOption.getAttribute('data-card-url') || fetchUrl,
                image: selectedOption.getAttribute('data-card-image')
            }).catch(function (err) {
                console.error('Error loading grouped product card:', err);
            });
        }
        return;
    }

    // Variant select inside .jspc-price (not grouped-product select)
    if (target && target.matches && target.matches('.jspc-price select') && !target.classList.contains('jspc-group-select')) {
        var select = target;
        var selectedVariantId = select.value;
        var selectedOption = select.options[select.selectedIndex];

        // Find parent .jspc-add-wrap
        var jspcAddWrap = select.closest('.jspc-add-wrap');
        if (jspcAddWrap) {
            if (selectedOption) {
                updateJspcAddCtaFromOption(jspcAddWrap, selectedOption);
            }

            // Update data-shows on .onetime-price to show correct price
            var onetimePrice = jspcAddWrap.querySelector('.onetime-price');
            if (onetimePrice) {
                // Get all select options to find the index of selected variant
                var options = select.querySelectorAll('option');
                var selectedIndex = -1;
                for (var i = 0; i < options.length; i++) {
                    if (options[i].value === selectedVariantId) {
                        selectedIndex = i;
                        break;
                    }
                }

                // Update data-shows with the index (0-based)
                if (selectedIndex >= 0) {
                    onetimePrice.setAttribute('data-shows', selectedIndex);
                    syncJspcOnetimePriceDisplay(onetimePrice);
                }
            }
        }
    }
});



function initReviewsIoRatingSnippets() {
    if (typeof ratingSnippet !== 'function') return;

    ratingSnippet('ruk_rating_snippet', {
        store: 'www.solidteknics.com',
        mode: 'default',
        color: '#0E1311',
        linebreak: false,
        text: 'Reviews',
        singularText: 'Review',
        lang: 'en',
        usePolaris: false,
        showEmptyStars: false,
        showNumericalAverageRating: false,
    });
}

function initReviewsIoProductRatingScroll() {
    if (!document.body.classList.contains('t-product')) return;

    document.addEventListener(
        'click',
        function (e) {
            var trigger = null;
            var path = typeof e.composedPath === 'function' ? e.composedPath() : [];

            for (var i = 0; i < path.length; i++) {
                var node = path[i];
                if (
                    node &&
                    node.nodeName &&
                    node.nodeName.toLowerCase() === 'reviewsio-product-ratings'
                ) {
                    trigger = node;
                    break;
                }
            }

            if (!trigger && e.target && typeof e.target.closest === 'function') {
                trigger = e.target.closest('reviewsio-product-ratings');
            }
            if (!trigger) return;

            var target = document.querySelector('reviewsio-product-reviews-widget');
            if (!target) return;

            e.preventDefault();
            e.stopPropagation();

            var headerOffset =
                parseInt(
                    getComputedStyle(document.body).getPropertyValue('--header-height') ||
                        '0',
                    10
                ) || 0;
            var top =
                target.getBoundingClientRect().top + window.scrollY - headerOffset - 16;

            window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        },
        true
    );
}

function initJspcImgSliders() {
    // Select all elements with the class 'jspcimg-slider'
    var sliders = document.querySelectorAll('.jspcimg-slider');
    sliders.forEach(function(slider) {
        // Check if Flickity is available and slider not already initialized
        if (typeof Flickity !== 'undefined' && !slider.classList.contains('flickity-enabled')) {
            // Initialize Flickity slider
            new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: true,
                imagesLoaded: true,
                wrapAround: true
            });
            // Remove the class to prevent re-initialization
            slider.classList.remove('jspcimg-slider');
        }
    });
}

// Call the function on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        initJspcImgSliders();
        initReviewsIoRatingSnippets();
        initReviewsIoProductRatingScroll();
    });
} else {
    initJspcImgSliders();
    initReviewsIoRatingSnippets();
    initReviewsIoProductRatingScroll();
}

